import { css } from '@emotion/react';
import { Box } from '@mui/material';
import { useCommunityContext } from 'providers';
import { Switch, Route } from 'react-router-dom';
import { guestRoutes } from 'routes';

import { processFilestackUrlSrcSet } from '@jebel/utils';

import { JEBEL_EMAIL_LOGO, JEBEL_LOGIN_SPLASH } from 'assets/images';
import { OnboardingLayout } from 'shared/components/layouts';
import { Skeleton } from 'shared/components/ui';

const SCHOOL_LOGO_HEIGHT = 96;

const containImageSize = css`
  img {
    object-fit: contain;
  }
`;

const emailLogoCSS = css`
  width: 100%;
  height: ${SCHOOL_LOGO_HEIGHT}px;
  object-fit: contain;

  ${containImageSize}
`;

export function OnboardingPagesRouter() {
  const { selectedCommunity: community, loading } = useCommunityContext();

  const emailImageUrl = community?.images?.emailLogo?.downloadUrl;
  const splashImageUrl = community?.images?.splashImage?.downloadUrl ?? undefined;

  return (
    <OnboardingLayout
      splashImage={splashImageUrl ?? JEBEL_LOGIN_SPLASH}
      splashImageTitle={community ? `${community.name} Splash Image` : `Jebel Splash Image`}
    >
      <Box display="grid" alignItems="center" justifyItems="center">
        <Skeleton width="100%" variant="rect" loading={loading}>
          <img
            css={emailLogoCSS}
            alt={`${community?.name} Email Logo`}
            src={emailImageUrl ? processFilestackUrlSrcSet(emailImageUrl) : JEBEL_EMAIL_LOGO}
          />
        </Skeleton>
      </Box>

      <Switch>
        {guestRoutes.map(({ routeComponent: RouteComponent = Route, component, path, ...rest }) => (
          <RouteComponent
            key={Array.isArray(path) ? path[0] : path}
            path={path}
            component={component}
            {...rest}
          />
        ))}
      </Switch>
    </OnboardingLayout>
  );
}
